module.exports = new __parcel__URL__("chatAppThreePhones.a1777fc1.png").toString();